<app-topheader></app-topheader>
<div class="scrollingcontainer container">


    <div *ngIf="pagemask==true">
        <div class="blueletters">First Day Aboard</div>
        <div class="blueletters">{{shipname}}</div>

        <div *ngFor="let port of CruisePCIInfo; let c = index;">
            <div *ngIf="c == 0"><app-port-info inputdate={{port.itiBegDate}}></app-port-info></div>
        </div>

        <div class="tenpxtop"></div>
        <div class="">

            <div class="row">
                <div class="col-4">
                    <div class="WeatherMain" *ngIf="WeatherData?.forecast?.forecastday.length>0">
                        <div class="weatherlabel center">Current Weather</div>
                        <div class="weathersection">
                            <div class="weatherimage center">
                                <i class="fa-thin weathericon" class={{WeatherIconData}}></i>
                            </div>

                            <div class="currenttemp center">
                                {{WeatherData?.current?.condition?.text}} | {{WeatherData?.current?.temp_f}}&deg;
                            </div>

                            <div class="highlow center">
                                Low {{WeatherData?.forecast?.forecastday[0]?.day?.mintemp_f}}&deg;
                            </div>

                            <div class="highlow center">
                                High {{WeatherData?.forecast?.forecastday[0]?.day?.maxtemp_f}}&deg;
                            </div>
                        </div>
                        <div class="row"></div>
                    </div>
                </div>
                <div class="col-8">
                    <div class="doublebuttonpadding">
                        <div class="mydaybuttonsholder" *ngIf="!lastday">
                            <div class="mydaybutton ">
                                <button type="button" class="btn  btn-light" disabled [routerLink]="['/mealdescription']">Menu Selections</button>
                            </div>
                        </div>
                    </div>            
                </div>
            </div>
            <div *ngFor="let port of CruisePCIInfo; let f = index;" class="row">
                <div *ngIf="f == 0"><app-myday-glance inputdate={{port.itiBegDate}}></app-myday-glance></div>
            </div>
        </div>

    </div>




    <div *ngIf="pagemask==false">

        <div class="blueletters">Today on {{shipname}}</div>

        <app-port-info></app-port-info>
        <div class="tenpxtop"></div>
        <div class="">

            <div class="row">
                <div class="col-4">
                    <app-weather></app-weather>
                </div>
                <div class="col-8">

                    <div class="doublebuttonpadding">
                        <div class="mydaybuttonsholder" *ngIf="!lastday">
                            <div class="mydaybutton ">
                                <button type="button" class="btn  btn-light" [routerLink]="['/mealdescription']">Menu
                                    Selections</button>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let iticodedata of iticodes; let j = index;">   
                        <div *ngIf="iticodedata.locallooptoday == true">
                            <div *ngIf="j==0 && iticodedata.ltcName!=''">
                                <div class="mydaybuttonsholder">
                                    <div class="mydaybutton ">
                                        <button type="button" class="btn  btn-light" [routerLink]="['/localloop', iticodedata.llcitiCode.slice(0, -1)+'&#37;']">View&nbsp;{{iticodedata.ltcName.split(':')[0]}}</button>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="j>0 && iticodes[j].ltcName!=iticodes[j-1].ltcName && iticodedata.ltcName!=''">
                                <div class="mydaybuttonsholder">
                                    <div class="mydaybutton ">
                                        <button type="button" class="btn  btn-light" [routerLink]="['/localloop', iticodedata.llcitiCode.slice(0, -1)+'&#37;']">View&nbsp;{{iticodedata.ltcName.split(':')[0]}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   

                </div>
            </div>
            <div class="row">
                <app-myday-glance></app-myday-glance>
            </div>
        </div>

    </div>

</div>
<app-bottommenu></app-bottommenu>